/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Title_PlaceholderInputs */

const en_admin_posts_title_placeholder = /** @type {(inputs: Admin_Posts_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post title`)
};

const zh_admin_posts_title_placeholder = /** @type {(inputs: Admin_Posts_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文章标题`)
};

/**
* | output |
* | --- |
* | "Post title" |
*
* @param {Admin_Posts_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_title_placeholder = /** @type {((inputs?: Admin_Posts_Title_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Title_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_title_placeholder(inputs)
	return zh_admin_posts_title_placeholder(inputs)
});
export { admin_posts_title_placeholder as "admin.posts.title_placeholder" }